import { KnownProduct } from "./KnownProduct.tsx";
import { useCreateHeyLightAdminAxiosInstance } from "../../Auth/useCreateHeyLightAdminAxiosInstance.ts";
import { HeyLightProductDTO } from "../../HeyLight/useHeyLightProductById.ts";
import { useState } from "react";

export type FPSProductInfo = Partial<{
  durationInWeeks: number;
  lessonsPerWeek: number;
  unlimitedLessonsPerWeek: boolean;
  totalLessons: number;
  extraWeek: boolean;
  warrantyMinAttendedLessons: number;
  warrantyEnabled: boolean;
  userGroupSlug: string;
  doNotEnroll: boolean;
  doNotMerge: boolean;
}>;

export function useCreateHeyLightProduct() {
  const { createAxiosInstance } = useCreateHeyLightAdminAxiosInstance();
  const [loading, setLoading] = useState(false);
  const createHeyLightProduct = async (input: {
    productName: string;
    internalProductName: string;
    priceInCents: {
      amount: number;
      currency: "EUR";
    };
    productClass: KnownProduct;
    purchaseAcTags: string[];
    refundAcTags: string[];
    successUrl: string;
    failureUrl: string;
    bundledProductIds: string[];
    allowedTerms: number[];
    peopleCount: number;
    fpsProductInfo?: FPSProductInfo;
    analyticsTag?: string;
  }): Promise<HeyLightProductDTO> => {
    try {
      setLoading(true);
      const { data } = await createAxiosInstance().post<HeyLightProductDTO>(
        `/product`,
        input,
      );
      return data;
    } finally {
      setLoading(false);
    }
  };

  return {
    createHeyLightProduct,
    loading,
  };
}
